// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@pace/App/Components/ProductDetails/ProductDetailsSummary";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

productDetailsSummaryStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};

productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        gap: 22px;
    `,
};

productDetailsSummaryStyles.rightSection = {
    css: css`
        min-width: 285px;
    `,
};

productDetailsSummaryStyles.productImage = {
    width: "91px",
    height: "91px",
};

productDetailsSummaryStyles.brandStyles = {
    nameLink: {
        typographyProps: {
            weight: fontConfig.weight.bold,
            color: "text.link",
            size: 12,
            css: css`
                && {
                    line-height: 17px;
                    display: block;
                }
            `,
        },
    },
};

productDetailsSummaryStyles.productTitle = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
};

productDetailsSummaryStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 540px;
        justify-content: center;
    `,
};

productDetailsSummaryStyles.actionStyles = {
    productGridContainer: {
        priceAndActions: {
            css: css`
                gap: 4px;
            `,
        },
    },
    priceBadgesContainer: {
        css: css`
            justify-content: end;
        `,
    },
    productActionsStyles: {
        addToCartContainer: {
            css: css`
                margin-top: 8px;
            `,
        },
    },
    productPriceStyles: {
        price: {
            priceText: {
                size: 20,
                weight: fontConfig.weight.bold,
                css: css`
                    &&& {
                        line-height: 26px;
                    }
                `,
            },
            unitOfMeasure: {
                unitOfMeasureText: {
                    size: 14,
                    lineHeight: "22px",
                },
            },
        },
    },
};
